export function getSearchWords (state){
	return state.query.w;
}
export function getSearchConditions (state){
	return state.query.c;
}
export function getChecked (state){
	return state.checked;
}
export function getSliderValue (state){
	return state.sliderValue;
}
export function getSCStr (state){
	return state.scstr;
}
export function getPrefecturesList (state){
	return state.prefecturesList;
}
export function getDistrict (state){
	return state.district;
}
export function getPrefectures (state){
	return state.prefectures;
}
export function getAreaCode (state){
	return state.areaCode;
}
export function getSituation (state){
	return state.situation;
}
export function getFacility (state){
	return state.facility;
}
export function getService (state){
	return state.service;
}
export function getImage (state){
	return state.image;
}
export function getSliderValueBtn (state){
	return state.sliderValueBtn;
}
export function getCheckedImage (state){
	return state.checkedImage;
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js